// Removes unescaped newlines and extra whitespace from
export const cleanInputValue = (str: string) => {
  let result = str.replace(/\n/g, " ");
  result = result.replace(/\s+/g, " ");
  result = result.trim();
  return result;
};
